import BackendSendApi from "../../../../../api/sm/market/printcoupon/BackendSendApi.js";

export default {
    paged:true,
    headers: [
        {text: '编号',value: 'id',sortable: false,width: 80,divider: true},
        {text: '店号',align: 'center',sortable: false,value: 'shopId',width: 80,divider: true},
        {text: '店名',align: 'start',sortable: false,value: 'shopName',width: 160,divider: true},
        {text: '款台号',align: 'center',sortable: false,value: 'sktno',width: 100,divider: true},
        {text: '小票号',align: 'center',sortable: false,value: 'fphm',width: 80,divider: true},

        {text: '券金额',align: 'center',sortable: false,value: 'couponAmount',width: 60,divider: true},

        {text: '操作员编号',align: 'start',sortable: false,value: 'operId',width: 120,divider: true},
        {text: '操作员名',align: 'start',sortable: false,value: 'operName',width: 100,divider: true},
        {text: '创建时间',align: 'start',sortable: false,value: 'createTime',width: 120,divider: true},
        

    ],

    transformQueryResultRec2EditorRec(queryResultRec){
        let editorRec = {};
        //注意，可能需要深度拷贝
        Object.assign(editorRec,queryResultRec);
        //editorRec.id=queryResultRec.userId;
        return editorRec;
    },

    async loadData(params,callback){
        let me = this;
        
        let aParam = {};
        Object.assign(aParam,params);
        aParam.orgId = params.orgId;

        let queryBackendSendResp = await BackendSendApi.queryBackendSend(aParam);
        console.log("load backendsend returned;");

        console.log(queryBackendSendResp);
        
        let data = queryBackendSendResp.data;
        if((!data)||(!(data.code))||(data.code!=200)){
            let msg=data.msg;
            msg = ((!msg)||(msg==''))?'获取后台送券记录数据失败':msg;
            throw new Error(msg);
            return;
        }
        if((!data.data)||(!data.data.backendSends)){
            throw new Error('获取后台送券失败(无数据)');
            return;
        }
        
        let backendSends = data.data.backendSends;
        let total = data.data.total;
        this.dealData(backendSends);
        callback({records:backendSends,total:total});
    },

    dealData(records){
        records.forEach(function(rec){
            null;
        });
    }
}


